// src/pages/common/COM002F1.jsx
import React, {useContext, useEffect, useState} from 'react';

import {AuthContext} from 'contexts/AuthContext';
import {MenuContext} from "./COM001L1";

import styled from "styled-components";
import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";

import style from "./COM002F1.module.scss";
import {Tooltip} from 'react-tooltip';
import Modal from "../../components/Modal/Modal";
import COM110M1 from "./COM110M1";

const   StyDiv = styled.div`
  display: flex;
  align-items: center;
  //justify-content: center;
  gap: 16px;
  
  height: ${props => ({ '0': '62px', '1': '59px', '2': '59px' })[props.$depth]};   
  color: ${props => props.$depth === 0 ? "#ffffff" : "#8B9FAF"};
  //padding-left: ${props => ({ '0': '0', '1': '10px', '2': '15px' })[props.$depth]};
  padding: ${props => props.$collapsed ? "0 28px":"0 24px"};  
  
  font-size: ${props => ({ '0': '20px', '1': '18px', '2': '16px' })[props.$depth]};
  font-weight: ${props => ({ '0': '600', '1': '700', '2': '700' })[props.$depth]};   
  font-family: Pretendard, sans-serif;
  
  background-color: ${props => props.$depth === 0 ? "#2B3944" : "#032030"};
  
  transition: all 0.3s ease;
  
  &:hover {
    color: #E4ECF4;
    cursor: pointer;
  }   
    
  .icoMenuTitle{
    position: relative;
    flex-shrink: 0; //변화 하지 않고 고정됨.
    width: ${props => ({ '0': '24px', '1': '22px', '2': '20px' })[props.$depth]};
    height: ${props => ({ '0': '24px', '1': '22px', '2': '20px' })[props.$depth]};
    
    background-image: url(${props => {
      let imageId = props.$menuId.substring(0, 2);
      return props.$depth === 0 && imageId ? require(`../../assets/images/ico_menuTitle_N_${imageId}.svg`) : "";
    }});
    
    background-size: ${props => props.$isLast ? '8px 8px' : (props.$depth > 0 ? '20px 20px' : 'cover')};
    background-repeat: no-repeat;
    background-position: center;
    //transition: none !important;
  }
 .tooltipText {
    background-color: #424242;
    font: 500 13px/1.5 Pretendard;
    color: #fff;
  }
`;

const COM002F1 = ({tabLength}) => {
  const [isModalChangePw, setIsModalChangePw] = useState(false); //모달 오픈여부(사용자 상세)

  const authContext = useContext(AuthContext);
  const userMenuList = authContext.menuList;
  const userInfo = authContext.userInfo; // 사용자 정보 가져오기

  const [menuList, setMenuList] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [collapseTrigger, setCollapseTrigger] = useState(0); // 메뉴 그룹 최소화 트리거

  //시간 연장 임시
  const handleClick_extend__button = (e) => {
    authContext.onTimeReset(); // 초기값으로 리셋
  };

  //내정보 변경
  const handleClick_changePw = (e) => {
      setIsModalChangePw(true);
  };
  const handleModalChangePw_Close = () => {
    setIsModalChangePw(false);
  }


  //입력된 탭의 값이 없을 경우 좌측 매뉴를 오픈한다.
  useEffect(() => {
    if(tabLength <= 0) setCollapsed(false);
  }, [tabLength]);

  useEffect(() => {
    const nest = (menuData, menuId = "ROOT") =>
      menuData.filter(item => item.upMenuId === menuId)
        .map(item => ({ ...item, childrens: nest(menuData, item.menuId) }));
    setMenuList(nest(userMenuList));
  }, [userMenuList]);

  return (
    <div className={`${style.leftNav_cont} ${collapsed ? style.collapsed : ""}`}>
      <div className={style.usrInfo_wrap}>
        <div className={style.usrInfo_box}>
          <div className={style.usrInfo_item}>
            <div className={style.stUserNm}>
              {/*<Icon id="user_02" width="32" height="32"/>*/}
              <img src={require('../../assets/images/ico_User_02.png')} alt="ICO_User" width={32} height={32} />
              {!collapsed && <span>{userInfo?.userNm}<label>님</label></span>}
            </div>
            <Button variant="Secondary" size="sm" addStyle={{width: "58px", height: "32px"}}
                    onClick={handleClick_changePw}>
              내정보
            </Button>
          </div>
          <hr/>
          <div className={style.usrInfo_item}>
            {!collapsed && <p><Icon id="clock_01" width="16" height="16" color="#ffffff"/>남은시간</p>}
            <h5 className={style.stActiveTime}>
              {Math.floor(authContext.timeLeft / 60)}:{('0' + (authContext.timeLeft % 60)).slice(-2)}
            </h5>
          </div>
          <div style={{ marginTop: collapsed ? "8px" : "12px" }}>
            <Button variant="Primary" size="sm" addStyle={{width: "100%", height: "32px"}} onClick={handleClick_extend__button}>
              시간연장
            </Button>
          </div>
        </div>
      </div>
      <div className={style.menuTree}>
        {menuList.map((subItem, index) =>
          <SubMenu item={subItem} key={index}
                   collapsed={collapsed} setCollapsed={setCollapsed}
                   collapseTrigger={collapseTrigger} setCollapseTrigger={setCollapseTrigger}
          />
        )}
      </div>
      <Modal
          open={isModalChangePw}
          handle_Close={handleModalChangePw_Close}
          title="사용자 정보변경"
          width ="736px"
          height="450px"
          isHeader={true}
          //bottomBtnText={{cancel:"취소텍스트",confirm:"확인 텍스트"}}
          bottomBtnText={{cancel:"취소",confirm:"변경(저장)"}}
          isBottom={false}>
        <COM110M1 handle_Close={handleModalChangePw_Close}
                  userId={userInfo.lginId}
        />
      </Modal>
    </div>
  );
}


const SubMenu = ({ item, depth = 0, collapsed, setCollapsed, collapseTrigger, setCollapseTrigger }) => {
  const [expanded, setExpanded] = useState(false);
  const { addPage } = useContext(MenuContext);

  // collapseTrigger가 변경되면 확장 닫기
  useEffect(() => {
    if (expanded) setExpanded(false);
  }, [collapseTrigger]);

  const handleClick_SbTitle = (e, item) => {
    e.preventDefault();
    if (item.childrens.length < 1) {
      addPage(item.menuId);
      setCollapsed(true); // 메뉴 클릭 시 사이드바 접기
      setCollapseTrigger(prev => prev + 1);
    } else {
      setCollapsed(false);
      setExpanded(prevValue => !prevValue);
    }
  };

  return (
    <>
      <StyDiv $expanded={expanded} $depth={depth} $isLast={item.childrens.length < 1} $menuId={item.menuId} $collapsed={collapsed}
          onClick={(e) => handleClick_SbTitle(e, item)}
      >
        {item.childrens.length > 0 &&
          <>
            <div className="icoMenuTitle" data-tooltip-id={item.menuId} data-tooltip-content={item.menuTl}>{/*아이콘*/}</div>
            {collapsed && <Tooltip id={item.menuId} place={"right"} className="tooltipText" />}
          </>
        }
        {!collapsed &&
          <>
            <span>{item.menuTl}</span>
            {item.childrens.length > 0  &&
              <button style={{marginLeft:"auto"}}>
                <Icon id={expanded ? "downAngleBrackets_02":"upAngleBrackets_02"} width="24" height="24" />
              </button>
            }
          </>
        }
      </StyDiv>
        {item.childrens.length > 0 &&
          <div className={`${style.SbItem} ${expanded ? style.expanded : ""}`} /*style={{ maxHeight: expanded ? '100%' : '0' }}*/>
            {item.childrens.map((child) => (
              <SubMenu item={child} depth={depth + 1} key={child.menuId}
                       collapsed={collapsed} setCollapsed={setCollapsed}
                       collapseTrigger={collapseTrigger} setCollapseTrigger={setCollapseTrigger}
              />
            ))}
          </div>
        }
    </>
  );
};

export default COM002F1;